module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/File-cloud-fafaf1b3280e3d6a2dfcdc498882cba9.svg";